import type { PartLike } from "./types";

/** Plan-hidden parts (lid copy, duplicate connector instance, …) on root or nested `properties`. */
export function isPartHiddenFromPlan(part: PartLike): boolean {
  if (part.dontShowInPlan === true) return true;
  return part.properties?.dontShowInPlan === true;
}
